import AsyncCreatableSelect from "react-select/async-creatable";
import AsyncSelect from "react-select/async";
import BasicSelect from "react-select";
import React from "react";

/**
 * A simple select, with search and creation options
 *
 * [ ABCDEF | V ]
 */
export function SelectInput({ select, value, onChange }) {
  return select.loadFunction && select.createFunction ? (
    <AsyncCreatableSelect
      isMulti={select.isMulti}
      menuPosition={"fixed"}
      className="basic-multi-select "
      placeholder="Select.."
      classNamePrefix="select"
      defaultOptions={true}
      value={select.getValue ? select.getValue(value) : value}
      onChange={(e) => {
        return select.setValue ? select.setValue(e) : onChange(e);
      }}
      onCreateOption={select.createFunction}
      getOptionValue={(v) => v.id}
      isClearable={select.isClearable === undefined ? true : select.isClearable}
      loadOptions={select.loadFunction}
      getOptionLabel={select.labelFunction}
    ></AsyncCreatableSelect>
  ) : select.loadFunction ? (
    <AsyncSelect
      isMulti={select.isMulti}
      placeholder="Select.."
      menuPosition={"fixed"}
      className="basic-multi-select"
      classNamePrefix="select"
      defaultOptions={true}
      value={value}
      onChange={(e) => {
        onChange(e);
      }}
      onCreateOption={select.createFunction}
      isClearable={select.isClearable === undefined ? true : select.isClearable}
      loadOptions={select.loadFunction}
      getOptionValue={(v) => v.id}
      getOptionLabel={select.labelFunction}
    ></AsyncSelect>
  ) : (
    <BasicSelect
      isClearable={select.clearable}
      value={select.options.filter((option) => {
        return option.value == value;
      })}
      placeholder="Select.."
      isMulti={select.isMulti}
      onChange={(e) => {
        onChange(e.value);
      }}
      className="basic-multi-select "
      classNamePrefix="select"
      options={select.options}
    ></BasicSelect>
  );
}
